import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';
import { ChannelIcon } from 'src/components/ChannelIcon';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { CHANNEL, getChannelDescription, getChannelPerformanceLabel } from 'src/data/channel';
import { CheckmarkIcon } from 'src/assets/icons/Checkmark';
import { isBetaChannel } from 'src/data/performance';
import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';

const getButtonLabel = (channel, isConnected) =>
  channel === CHANNEL.emailChannel ? 'Upload' : isConnected ? 'Add account' : 'Connect';

export const Channel = memo(({ channel, isConnected, onClick }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <ChannelIcon
          channel={channel}
          className={styles.channelIcon}
        />
        <CustomTypography variant={TYPOGRAPHY_VARIANT.medium16}>
          {getChannelPerformanceLabel(channel)}
        </CustomTypography>
        {isConnected && (
          <>
            <CheckmarkIcon className={styles.checkmarkIcon} />
            <CustomTypography
              variant={TYPOGRAPHY_VARIANT.medium12}
              className={styles.connected}
            >
              Connected
            </CustomTypography>
          </>
        )}
        {isBetaChannel(channel) && (
          <CustomTypography className={styles.betaTag}>Beta</CustomTypography>
        )}
      </div>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.paragraph14}
        className={styles.description}
      >
        {getChannelDescription(channel)}
      </CustomTypography>
      <CustomButton
        key={channel}
        className={styles.connectButton}
        data-testid={`connectButton_${channel}`}
        variant={CUSTOM_BUTTON_VARIANT.outlined}
        size={CUSTOM_BUTTON_SIZE.small}
        onClick={() => onClick(channel)}
      >
        {getButtonLabel(channel, isConnected)}
      </CustomButton>
    </div>
  );
});

Channel.propTypes = {
  isConnected: PropTypes.bool,
  channel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
Channel.defaultProps = {
  isConnected: false,
  channel: null,
};
